<div class="appointments">
  <div class="appointments-container">
    <div id="calendar" class="incoming-refferals">
      <div class="patient-search-calendar">
        <span class="patient-seach-apts">
                    <nz-select [visible]="
        calendarVisible() &&
        calendarElement &&
        calendarElement.getApi().view.type == 'resourceTimeline'
      " style="margin-bottom: 10px; width: 300px" [nzPlaceHolder]="'Search Patients' | translate" nzShowSearch
            nzAllowClear (ngModelChange)="handlePatientSelect($event)" [(ngModel)]="selectedPatientId">
            @for (patient of originalPatientsList; track patient) {
              <nz-option [nzValue]="patient.id"
              [nzLabel]="patient.title"></nz-option>
            }
          </nz-select></span>
        </div>

        @if (!calendarVisible()) {
          <div fxLayout="column" fxLayoutAlign="center center" class="calendar-spinner">
            <h2>{{ "Processing" | translate }}...</h2>
            <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
          </div>
        }

        @if (calendarVisible()) {
          <full-calendar #calendar [options]="calendarOptions()">
          </full-calendar>
        }
      </div>
    </div>
  </div>

  <!-- These are dynamically loaded components -->
  <div *ngComponentOutlet="addCalentarEventComp"></div>
  <div *ngComponentOutlet="viewCalentarEventComp"></div>